import {
    INFORMES_LIST,
    INFORMES_LISTA,
    INFORMES_READ,
    INFORMES_FILTER,
    INFORMES_CREATE,
    INFORMES_UPDATE,
    INFORMES_UPDATE_SUCCESS,
    INFORMES_CREATE_SUCCESS,
    INFORMES_LIST_SUCCESS,
    INFORMES_REQUEST_FAILED,
    INFORMES_READ_SUCCESS,
  } from "./actionTypes";
  
  export const informesList = () => {
    return {
      type: INFORMES_LIST,
      payload: {},
    };
  };
  export const informesLista = () => {
    return {
      type: INFORMES_LISTA,
      payload: {},
    };
  };
  
  export const informesCreate = (informes) => {
    return {
      type: INFORMES_CREATE,
      payload: informes,
    };
  };
  
  export const informesFilter = (changeUrl) => {
    return {
      type: INFORMES_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const informesUpdate = (id, data) => {
    return {
      type: INFORMES_UPDATE,
      payload: { id, data },
    };
  };
  
  export const informesListSuccess = (informes) => {
    return {
      type: INFORMES_LIST_SUCCESS,
      payload: informes,
    };
  };
  
  export const informesCreateSuccess = (informesCreated) => {
    return {
      type: INFORMES_CREATE_SUCCESS,
      payload: informesCreated,
    };
  };
  
  export const informesUpdateSuccess = (informes) => {
    return {
      type: INFORMES_UPDATE_SUCCESS,
      payload: informes,
    };
  };
  export const informesRead = (informes) => {
    return {
      type: INFORMES_READ,
      payload: informes,
    };
  };
  export const informesReadSuccess = (informes) => {
    return {
      type: INFORMES_READ_SUCCESS,
      payload: informes,
    };
  };
  
  export const informesRequestFailed = (error) => {
    return {
      type: INFORMES_REQUEST_FAILED,
      payload: error,
    };
  };
  